/* eslint-disable max-statements */
import { addTransportToBasket, createBasket } from '../../api/basket';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { basketOperations, basketTypes } from '../../store/basket';
import { DAS_ADD_TRANSPORT_TO_BASKET_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';

const { sendMessage } = messageOperations;
const { ADD_TRANSPORT_TO_BASKET } = basketTypes;

export const performAddTransportToBasket = function* performAddTransportToBasket({
  payload,
}) {
  const {
    addToBasketFailed,
    createBasketSuccess,
    resetBasket,
  } = basketOperations;
  let { basketPax } = payload;

  try {
    if (!payload.hasBasket) {
      const createBasketResponse = yield call(createBasket, payload.bookingRef);

      if (createBasketResponse.errors) {
        yield all(
          createBasketResponse.errors.map(error => put(createError(error))),
        );

        return;
      }

      yield put(
        createBasketSuccess(
          createBasketResponse.bookingRef,
          createBasketResponse.basket,
        ),
      );

      basketPax = createBasketResponse.basket.pax || [];
    }

    const transport = payload.transport.map(tPax => ({
      ...tPax,
      pax_id: basketPax.find(bPax => bPax.customer_id === tPax.pax_id).id,
    }));
    const addToBasketResponse = yield call(
      addTransportToBasket,
      payload.bookingRef,
      transport,
    );

    if (addToBasketResponse.errors) {
      yield all(
        addToBasketResponse.errors.map(error => put(createError(error))),
      );
      yield put(addToBasketFailed());

      if (!payload.hasBasket) {
        yield put(resetBasket(payload.bookingRef));
      }

      return;
    }

    const basketResponse = yield call(reloadBasket, payload.bookingRef);

    if (basketResponse.errors) {
      return;
    }

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: 'Transport added to basket',
      }),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_ADD_TRANSPORT_TO_BASKET_FAILED,
      }),
    );
    yield put(addToBasketFailed());

    if (!payload.hasBasket) {
      yield put(resetBasket(payload.bookingRef));
    }
  }
};

export default takeLatest(ADD_TRANSPORT_TO_BASKET, performAddTransportToBasket);
